import React, { useState } from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';
import { COMPONENT_TYPES } from './componentTypes';

const ComponentPickerModal = ({ onClose, onSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredComponents = COMPONENT_TYPES.filter(comp => 
    comp.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    comp.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-[var(--bg-secondary)] rounded-lg shadow-xl w-full max-w-md max-h-[80vh] flex flex-col">
        <div className="p-4 border-b border-[var(--border-color)] flex justify-between items-center">
          <h3 className="text-lg font-bold text-[var(--text-primary)]">Add Component</h3>
          <button onClick={onClose} className="text-[var(--text-secondary)] hover:text-[var(--text-primary)]">
            <FaTimes />
          </button>
        </div>
        
        <div className="p-4">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <FaSearch className="text-[var(--text-secondary)]" />
            </div>
            <input
              type="text"
              className="w-full pl-10 pr-4 py-2 bg-[var(--bg-primary)] text-[var(--text-primary)] border border-[var(--border-color)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
              placeholder="Search components..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>
        </div>
        
        <div className="overflow-y-auto flex-1">
          {filteredComponents.length > 0 ? (
            <ul className="">
              {filteredComponents.map((component) => (
                <li key={component.type}>
                  <button
                    onClick={() => onSelect(component.type)}
                    className="w-full p-4 flex items-center hover:bg-[var(--bg-hover)] transition-colors"
                  >
                    <div className="mr-3 text-2xl text-[var(--primary)]">
                      {component.icon}
                    </div>
                    <div className="text-left">
                      <h4 className="font-medium text-[var(--text-primary)]">{component.name}</h4>
                      <p className="text-sm text-[var(--text-secondary)]">{component.description}</p>
                    </div>
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <div className="p-4 text-center text-[var(--text-secondary)]">
              No components found matching "{searchTerm}"
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ComponentPickerModal;